import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Collapse, Form, Row, Card} from "react-bootstrap";
import {useFragment} from "react-relay";
import Flex from "../../components/common/Flex";

const BillingGroupPractitionerFilters = ({params, onParamsChange, onParamsEnter, onSearch, onClearFilters, isLoading}) => {
    return (
        <Card.Header>
            <h2 className={"fs--1 mb-3 text-600 text-uppercase"}>Search</h2>
            <Row className={"g-3 mb-1"}>
                <Col md={3}>
                    <Form.Group controlId={"firstName"}>
                        <Form.Label className={"text-700"}>First Name</Form.Label>

                        <Form.Control size={"sm"}
                                      name={"firstName"}
                                      value={params.firstName || ""}
                                      onChange={onParamsChange}
                                      onKeyDown={onParamsEnter}
                        />
                    </Form.Group>

                </Col>
                <Col md={3}>
                    <Form.Group controlId={"lastName"}>
                        <Form.Label className={"text-700"}>Last Name</Form.Label>
                        <Form.Control size={"sm"}
                                      name={"lastName"}
                                      value={params.lastName || ""}
                                      onChange={onParamsChange}
                                      onKeyDown={onParamsEnter}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className={"g-3 mb-1"}>
                <Col md={3}>
                    <Form.Group controlId={"npi"}>
                        <Form.Label className={"text-700"}>NPI</Form.Label>
                        <Form.Control size={"sm"}
                                      name={"npi"}
                                      value={params.npi || ""}
                                      onChange={onParamsChange}
                                      onKeyDown={onParamsEnter}
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group controlId={"locationName"}>
                        <Form.Label className={"text-700"}>Location Name</Form.Label>
                        <Form.Control size={"sm"}
                                      name={"locationName"}
                                      value={params.locationName || ""}
                                      onChange={onParamsChange}
                                      onKeyDown={onParamsEnter}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Flex justifyContent={"end"}>
                <Button className={"mx-2"} variant="primary"
                        onClick={onSearch}>{isLoading ? "Searching..." : "Search"}</Button>
                <Button variant="falcon-default" onClick={onClearFilters}>Clear Filters</Button>
            </Flex>
        </Card.Header>
    )
}
export default BillingGroupPractitionerFilters